import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles(() => ({
  allButtons: {
    width: '100%',
    display: 'flex',
    background: 'white',
    justifyContent: 'space-between',
    marginRight: ({ noMargin }) => (noMargin ? '' : '15px'),
    marginLeft: ({ leftButton, leftButtonNoMargin }) =>
      leftButton && leftButtonNoMargin ? '0px' : '15px',
    marginBottom: '10px',
  },
  buttons: {
    width: '100%',
    display: 'flex',
    justifyContent: 'flex-end',
  },
  textType: {
    textTransform: 'initial',
  },
  cancel: {
    textTransform: 'initial',
    marginRight: '8px',
  },
}))
